import { getFormattedDate } from './date-helper.js';

export function prepareDateToApi(inputDate) {
    const { year, month, date } = getFormattedDate(inputDate);
    const selectedDate = new Date(year, month - 1, date);
    const dateAfterMonth = new Date(
        selectedDate.getTime() + 30 * 24 * 60 * 60 * 1000
    );

    return {
        fromDate: getFormattedDate(inputDate),
        toDate: getFormattedDate(dateAfterMonth)
    };
}
